import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import compose from 'recompose/compose';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { DeleteIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';

const DeleteButton = (props) => {
    const { action, dispatchAction, record, translate } = props;

    return (
        <Button
            icon={ <DeleteIcon color={ theme.palette.doveGray }/> }
            title={ translate('actions.delete') }
            onClick={ () => {
                return dispatchAction(action(record));
            } }
            primary={ false }
        />
    );
};

DeleteButton.propTypes = {
    action: PropTypes.func.isRequired,
    record: PropTypes.object.isRequired,
    dispatchAction: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAction: (func) => {
            dispatch(func);
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps
    ),
    translate,
);

export default enhance(DeleteButton);



// WEBPACK FOOTER //
// ./src/components/button/DeleteButton.js